import { lazyWithSuspense } from '~/utilities/lazyWithSuspense';
import type { RecordRoomEntryProps } from '~/singlePageApp/screens/GroupRecord/types';
import { ScreenContainer } from '../../layouts/shared/ScreenContainer';
import { ScreenHeader } from '../../layouts/SidePanelLayout/ScreenHeader';

export const RecordRoomEntry = lazyWithSuspense<RecordRoomEntryProps, 'RecordRoomEntry'>(
  async () => import('./RecordRoomEntry'),
  {
    exportKey: 'RecordRoomEntry',
    loadingState: (
      <>
        <ScreenHeader />
        <ScreenContainer />
      </>
    ),
  },
);
